import Taxonomy from 'umg-ember-backend/components/record-explorer/for/taxonomy';

<template><Taxonomy @records={{@model}} @recordType='taxonomy' /></template>
